export const CREATE_NEW_SCHEDULE_BUTTON = 'Create New Schedule'
export const SELECT_A_CLIENT_ERROR = 'Please Select a Client'
export const CLIENT_LABEL = 'Client'
export const DEFAULT_AUTOCOMPLETE_SUGGESTION = 'Begin typing to search clients'
export const CREATE_NEW_SCHEDULE_TITLE = 'Create a new schedule to get started.'
